import React from "react";

interface AvatarProps {
  name: string;
  size?: number;
  fontSize?: number;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  name,
  size = 40,
  fontSize = 16,
  className = "",
}) => {
  const getInitials = (name: string): string => {
    if (!name.trim()) return "";

    const names = name.trim().split(" ");
    let initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }

    return initials;
  };

  const colors = [
    "#FF6633",
    "#2D2B64",
    "#FF33FF",
    "#FFFF99",
    "#00B3E6",
    "#E6B333",
    "#3366E6",
    "#999966",
    "#99FF99",
    "#B34D4D",
    "#80B300",
    "#809900",
    "#E6B3B3",
    "#6680B3",
    "#66991A",
  ];

  const getColorFromInitials = (initials: string): string => {
    const charCodeSum = initials[0]
      .split("")
      .reduce((sum, char) => sum + char.charCodeAt(0), 0);
    return colors[charCodeSum % colors.length];
  };

  const initials = getInitials(name);
  const bgColor = getColorFromInitials(initials);
  const textColor = "#ffffff"; // White text for better contrast

  return (
    <div
      className={`avatar ${className}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        backgroundColor: bgColor,
        color: textColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: `${fontSize}px`,
        fontWeight: "bold",
        userSelect: "none",
      }}
      aria-label={`Avatar for ${name}`}
    >
      {initials}
    </div>
  );
};

export default Avatar;
